import React from "react";

import FrequentlyBoughtItemsWith from "./FrequentlyBoughtItemsWith";
import { numberConversion } from "../../../../utils";
import "../../index.css"

const ProductViewModal = (props) =>{
    const { viewProductId, products, materialBrands, company, cartItems, setCartItems, updateCartItems, handleViewProduct } = props

    const eachProduct = products.find(eachProduct => eachProduct.buyerRateContractId === viewProductId)

    if(!eachProduct) {
        return null
    }

    const relatedCartItem = cartItems.find(prod => {
        return prod.buyerRateContractId == eachProduct.buyerRateContractId
    })
    
    const relatedMaterialBrand = materialBrands.find(eachMaterialBrand => eachMaterialBrand.brandId === eachProduct.brandId)

    const materialImage = eachProduct.materialImage?.length > 0 ? eachProduct.materialImage[0] : "https://procmart-tech.s3.ap-south-1.amazonaws.com/app-images/no_image_no_pg+(4).png"

    const handleQuantityChange = (event, selectedItem) => {
        cartItems.map(eachCartItem => {
            if (eachCartItem.buyerRateContractId === selectedItem.buyerRateContractId) {
                eachCartItem.quantity = event.target.value
            }
        })
        setCartItems([...cartItems])
    }

    return(
        <div>
            <div className="modal fade theme-modal view-modal product-view-modal" id="view" tabindex="-1">
                <div className="modal-dialog modal-dialog-centered modal-xl modal-fullscreen-sm-down">
                    <div className="modal-content">

                        <div className="modal-body p-3 pt-0">
                            <div className="row g-sm-4 g-2 col-12 flex flex-row">
                                <div className="col-lg-6 w-4 pl-3 pr-3 mr-3 slider-image-container">
                                    <div className="slider-image">
                                        <img src={materialImage} className="img-fluid lazyload"
                                            alt="" style={{ maxWidth: "100%", maxHeight: "300px", objectFit: "contain" }}></img>
                                    </div>
                                </div>

                                <div className="col-lg-6 w-8">
                                    <div className="right-sidebar-modal">
                                        <h4 className="title-name">{eachProduct.companyProdName}</h4>
                                        <h4 className="price">₹ {numberConversion(eachProduct.unitPrice, "en-IN")}</h4>
                                        <div className="product-detail">
                                            <h4>Product Details :</h4>
                                            <p>{eachProduct.companyProdSpec}</p>
                                        </div>
                                        <ul className="brand-list">
                                            <li>
                                                <div className="brand-box">
                                                    <h5>Brand Name:</h5>
                                                    <h6>{relatedMaterialBrand.brandName}</h6>
                                                </div>
                                            </li>
                                            { eachProduct.companyERPCode ? 
                                                <li>
                                                    <div className="brand-box">
                                                        <h5>ERP Code:</h5>
                                                        <h6>{eachProduct.companyERPCode}</h6>
                                                    </div>
                                                </li> : null 
                                            }
                                            { eachProduct.companyGSTOverride && 
                                                <li>
                                                    <div className="brand-box">
                                                        <h5>GST (%):</h5>
                                                        <h6>{eachProduct.companyGSTOverride} %</h6>
                                                    </div>
                                                </li>
                                            }
                                            <li>
                                                <div className="brand-box">
                                                    <h5>Lead Time:</h5>
                                                    <h6>{eachProduct.leadTime} days</h6>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="brand-box">
                                                    <h5>Product Type:</h5>
                                                    <h6>{eachProduct.companyERPCategory}</h6>
                                                </div>
                                            </li>
                                        </ul>
                                        { company?.tags?.canAddRateContract ? <>
                                            {
                                                !relatedCartItem || (relatedCartItem && relatedCartItem.quantity === 0) ?
                                                <div className="modal-button">
                                                    <button onclick="location.href = 'cart.html';" className="btn btn-md add-cart-button icon" onClick={() => updateCartItems("ADD", eachProduct)}>Add To Cart</button>
                                                </div>
                                                :
                                                <>
                                                    <div className="cart_qty qty-box">
                                                        <div className="input-group flex bg-white">
                                                            <button type="button" className="qty-left-minus bg-gray"
                                                                data-type="minus" data-field="" onClick={() => updateCartItems("DECREASE", relatedCartItem)} >
                                                                <i className="fa fa-minus"></i>
                                                            </button>
                                                            <input
                                                                className=""
                                                                style={{width: "100px"}}
                                                                type="text"
                                                                name="quantity"
                                                                placeholder="Quantity"
                                                                value={relatedCartItem.quantity}
                                                                onChange={(e) => handleQuantityChange(e, relatedCartItem)}
                                                                onBlur={() => updateCartItems("SET", relatedCartItem)}
                                                            >
                                                            </input>
                                                            <button type="button" className="qty-right-plus bg-gray"
                                                                data-type="plus" data-field="" onClick={() => updateCartItems("INCREASE", relatedCartItem)}>
                                                                <i className="fa fa-plus"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </>
                                            } </> : "" 
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <FrequentlyBoughtItemsWith 
                products={products}
                eachProduct={eachProduct}
                handleViewProduct={handleViewProduct}
            />
        </div>
    )
}

export default ProductViewModal